module.exports = __webpack_public_path__ + "img/code.1d5c5f91.png";